import React from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { toast } from "react-toastify";
import { ModalBanner } from "../../assets";
import { NewTabbedTable } from "../../components/UI";
import { MilestonesCanvas } from "../../assets";
import moment from "moment";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import axios from "axios";
import { MemberShip1, MemberShip2 } from "../../assets";
import NoDataAvailable from "../../components/front/partner/NoDataAvailable";
import {
  constructDateOnlyWithTimeZone,
  constructTimeRangeFromDecimalHours,
  getFormattedTimeRange,
  getFormattedDateRange,
  getGroupedWeekdayRange,
  buildScheduleForProduct,
  prepareClosureDates,
  makeUTCDateTimeAsLocalTZ
} from "../../pages/front/SpecificPageUtils/utils";
import { DateTime } from "luxon";
import "../../assets/css/componentSpecificCss/PreviewProgramListingsModal.css";

class PreviewMembershipListingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      memberships: []
    };
  }

  getDisplayableDateAndTimeRangeForEvents = e => {
    //Changes were made in the API to return IANA timezone info (eg. America/Toronto) with every product listing.
    console.assert(e.timezone, "timezone not provided for partner/educator!");

    //For events, server+database stores the time UTC+0 timezone, eg. 2021-10-01 T 04:00:00.000 Z
    const eventStart = DateTime.fromISO(e.event_start);
    const eventEnd = DateTime.fromISO(e.event_end);

    //Now we set the timezone to that of the partner!             e.g. 2021-10-01 T 00:00:00.000 -04:00
    //...and it makes appropriate adjustment if it's not daylight time, eg. -05:00
    const rezonedStart = eventStart.setZone(e.timezone);
    const rezonedEnd = eventEnd.setZone(e.timezone);

    //Tried the following 2 lines -- now commented out! They don't work! Possibly due to older Luxon version.
    //const rezonedStart = DateTime.fromISO( e.event_start, {zone:e.timezone, setZone:true} );
    //const rezonedEnd = DateTime.fromISO( e.event_end, {zone:e.timezone, setZone:true} );

    return {
      formattedTimeRange: getFormattedTimeRange(rezonedStart, rezonedEnd),
      formattedDateRange: getFormattedDateRange(rezonedStart, rezonedEnd)
    };
  };

  onBeforeDragStart = () => {
    this.setState({ isDragging: true });
  };

  onDragEndHandler = async (destination, source, draggableId) => {
    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const itemList = this.state.memberships;

    const newList = [...itemList];
    const draggedItem = newList[source.index];
    newList.splice(source.index, 1);
    newList.splice(destination.index, 0, draggedItem);

    this.setState({ memberships: newList });
  };

  onDragEnd = ({ destination, source, draggableId }) => {
    this.onDragEndHandler(destination, source, draggableId);
    this.setState({ isDragging: false });
  };

  componentDidMount() {
    this.addScrollWheelListener();

    this.setState({
      memberships: this.props.memberships
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isDragging !== this.state.isDragging) {
      this.addScrollWheelListener();
    }
  }

  componentWillUnmount() {
    this.removeScrollWheelListener();
  }

  addScrollWheelListener() {
    if (this.state.isDragging) {
      window.addEventListener("wheel", this.handleScroll, { passive: false });
    } else {
      this.removeScrollWheelListener();
    }
  }

  removeScrollWheelListener() {
    window.removeEventListener("wheel", this.handleScroll);
  }

  handleScroll = event => {
    event.preventDefault();
  };

  getDisplayableDateAndTimeRangeForPrograms = (p, alsoDateRange) => {
    //Changes were made in the API to return IANA timezone info (eg. America/Toronto) with every product listing.
    console.assert(p.timezone, "timezone not provided for partner/educator!");

    let { dateOnlyWithTZ, formattedDate } = constructDateOnlyWithTimeZone(
      p.program_start,
      p.timezone
    );

    let formattedTimeRange = "--";
    if (
      p.timing &&
      p.timing.length === 2 &&
      p.timing[0] !== "-1" &&
      p.timing[1] !== "-1"
    ) {
      // timezone_offset is a deprecated column and marked for removal in the future!
      const timezone_offset = p.timezone_offset || 0;
      //column was only available for online virtual products! So flag it, if non-zero or non-null!
      console.assert(
        timezone_offset === 0,
        `expecting timezone_offset column for OnlineVirtual#${p.id} to be zero or null!`
      );

      //Below, "dateOnlyWithTZ" is used to frame the time ranges within the correct timezone.
      let { startTime, endTime } = constructTimeRangeFromDecimalHours(
        parseFloat(p.timing[0]) -
          timezone_offset /*@@DEPRECATED@@: Will remove timezone_offset column in the future!*/,
        parseFloat(p.timing[1]) -
          timezone_offset /*@@DEPRECATED@@: Will remove timezone_offset column in the future!*/,
        dateOnlyWithTZ
      );
      formattedTimeRange = getFormattedTimeRange(startTime, endTime);
    }

    if (alsoDateRange) {
      const formattedDateRange = getFormattedDateRange(
        dateOnlyWithTZ,
        p.program_final_date,
        " to ",
        true
      );
      return { formattedTimeRange, formattedDate, formattedDateRange };
    } else {
      return { formattedTimeRange, formattedDate };
    }
  };

  render() {
    return (
      <div className="request-modal-cont">
        <div
          className="request-modal lesspadding"
          id="program-listing-preview"
          style={{ maxWidth: "650px", maxHeight: "100%", overflowY: "hidden" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              //   alignItems: "center",
              height: "48px",
              paddingLeft: "20px",
              borderBottom: "1px solid lightgrey"
            }}
          >
            <h3 style={{ color: "#2938be", paddingLeft: "20px" }}>
              Membership Listing Preview
            </h3>
            <IconButton
              style={{
                borderRadius: "50%",
                color: "#2880FF",
                marginBottom: "0.5rem"
              }}
              onClick={_ => this.props.onClose()}
            >
              <Close />
            </IconButton>
          </div>
          <div
            style={{ overflowY: "auto", overflowX: "hidden", height: "400px" }}
          >
            <div>
              <div
                className="container-fluid adminprofiles"
                style={{ background: "#f7f7f8" }}
              >
                <div
                  className="row"
                  style={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    paddingBottom: "1rem",
                    paddingTop: "5px"
                  }}
                >
                  <>
                    <div style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
                      <div className="tablecont">
                        <div
                          className="table-responsive"
                          style={{ fontSize: "16px", overflowY: "hidden" }}
                        >
                          {this.state.memberships.length > 0 ? (
                            <DragDropContext
                              onDragEnd={this.onDragEnd}
                              onBeforeDragStart={this.onBeforeDragStart}
                            >
                              <Droppable droppableId="membershipTableItems">
                                {(provided, snapshot) => (
                                  <tbody
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    // style={getListStyle(snapshot.isDraggingOver)}
                                  >
                                    {this.state.memberships
                                      .filter(e => e.published)
                                      .map((row, k) => {
                                        const {
                                          formattedTimeRange,
                                          formattedDateRange
                                        } =
                                          this.getDisplayableDateAndTimeRangeForEvents(
                                            row
                                          );

                                        return (
                                          <Draggable
                                            draggableId={`${row.id}`}
                                            index={k}
                                            key={row.id}
                                          >
                                            {(provided, snapshot) => {
                                              return (
                                                <tr
                                                  key={k}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  ref={provided.innerRef}
                                                >
                                                  <div
                                                    className={`preview-card`}
                                                    style={{
                                                      height: "60px",
                                                      marginBottom: "5px"
                                                    }}
                                                  >
                                                    <LazyLoadImage
                                                      src={
                                                        row.membership_image ===
                                                        2
                                                          ? `${process.env.REACT_APP_DS_FILES_S3}/${row.membership_image_url}`
                                                          : row.membership_image ===
                                                            0
                                                          ? MemberShip1
                                                          : MemberShip2
                                                      }
                                                      alt="Program"
                                                      // className={
                                                      //   this.props.classes
                                                      //     .cardImg
                                                      // }
                                                      //   wrapperClassName="card-img"
                                                      className={
                                                        "preview-image"
                                                      }
                                                      effect="opacity"
                                                    />

                                                    <div className="card-content-preview">
                                                      <div className="card-sub1 card-sub1-preview">
                                                        <h4
                                                          className="sub1-name"
                                                          id="sub1-name-preview"
                                                        >
                                                          {row.membership_name}
                                                        </h4>
                                                      </div>
                                                      {/* <div className="card-sub2">
                                                        <h4
                                                          className="sub2-timing"
                                                          style={{
                                                            fontSize: "12px"
                                                          }}
                                                        >
                                                          {formattedTimeRange}
                                                        </h4>
                                                        <div
                                                          className="sub2-date-preview"
                                                          style={{
                                                            fontSize: "10px"
                                                          }}
                                                        >
                                                          {formattedDateRange}
                                                        </div>
                                                      </div> */}
                                                      {/* <div className="card-sub3">
                                                        <h4 className="sub3-pricing">
                                                          {priceText}
                                                        </h4>
                                                      </div> */}
                                                    </div>
                                                  </div>
                                                </tr>
                                              );
                                            }}
                                          </Draggable>
                                        );
                                      })}
                                  </tbody>
                                )}
                              </Droppable>
                            </DragDropContext>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
          <div className="preview-listing-footer">
            <button
              className="preview-listing-btn"
              onClick={async () => {
                const updateOrderEp = `${process.env.REACT_APP_API}/partners/memberships/updateOrder`;
                const resultUpdateOrder = await axios.put(
                  updateOrderEp,
                  this.state.memberships
                );
                if (resultUpdateOrder.data.success) {
                  toast.success("Listings Order Saved!");
                  this.props.onOrderSave(this.state.memberships);
                  this.props.onClose();
                }
              }}
            >
              Save Listing Order
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PreviewMembershipListingsModal);
